import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/auth-store';
import { AuthContext } from '@/contexts/auth-context';
import type { ReactNode } from 'react';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { i18n } = useTranslation();
  const { user, checkAuth } = useAuthStore();

  // Initialize auth check on mount
  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sync user's language preference when user changes (login/logout)
  useEffect(() => {
    if (user?.language) {
      // User has a language preference, use it
      i18n.changeLanguage(user.language);
    }
    // If no user is authenticated, let the language detector handle it
    // Don't force any specific language
    // Note: i18n is intentionally NOT in dependencies to avoid resetting
    // the language when user manually changes it via LanguageSwitcher
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.language]);

  return <AuthContext.Provider value={{}}>{children}</AuthContext.Provider>;
}
